import React, { useState } from "react";
import {
  Modal,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../Utils/Loaders";
import { toast, ToastContainer } from "react-toastify";
import { saveNewCategory } from "../../../api/clinicalTrial";
import { attachmentEntityType } from "../../../variables/Enums";

export const ModalCreateRegulatoryCategory = ({ show, onClose, onSave }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");

  const [saving, setSaving] = useState(false);

  const handleChange = (value) => {
    setName(value);
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const payload = {
        fileName: name,
        entityType: attachmentEntityType.RegulatorySubmissions,
        multipleFiles: false,
      };

      const response = await saveNewCategory(payload);

      if (response.status === 200) {
        onSave(response.data.id, name);
        onClose();
        return;
      }

      toast.error(t("errors.serverError"));
    } catch (err) {
      toast.error(t("errors.serverError"));
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t("regulatorySubmissions.createRegulatoryCategoryModal.title")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormGroup controlId="formTitle">
          <ControlLabel>
            {t("regulatorySubmissions.createRegulatoryCategoryModal.nameLabel")}{" "}
            <span className="text-danger">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            placeholder="Nombre"
            value={name}
            onChange={(e) => handleChange(e.target.value)}
          />
        </FormGroup>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {t("regulatorySubmissions.createEditModal.cancelLabel")}
        </Button>
        {saving && <Spinner />}
        {!saving && (
          <Button
            variant="btn btn-primary"
            onClick={handleSubmit}
            disabled={!name}
          >
            {t("regulatorySubmissions.createEditModal.acceptLabel")}
          </Button>
        )}
      </Modal.Footer>
      <ToastContainer position="top-right" pauseOnHover />
    </Modal>
  );
};
